import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=085e6782"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=085e6782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports